module.exports = {"341002001":"昱东街道","341002002":"昱中街道","341002003":"昱西街道","341002004":"老街街道","341002100":"屯光镇","341002101":"阳湖镇","341002102":"黎阳镇","341002103":"新潭镇","341002104":"奕棋镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341002.json
// module id = 1210
// module chunks = 0